import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'enable'
})
export class EnableStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    for (let tableIndex = 0; tableIndex < args.length; tableIndex++) {
      if (args[tableIndex].value == value) {
        return args[tableIndex].text;
      }
    }
    return '无';
  }

}
